export const getEmailDomain = () => {
  const domain =
    process.env.PROXY_TO_ENV === 'prod'
      ? 'app'
      : process.env.PROXY_TO_ENV || 'staging';
  return `${domain}.usehatchapp.com`;
};
